export default {
    COEF_UPDATE_COMPETITIONS: [
        {
            rs_name: 'MONTPELLIER THROWDOWN 2022 – FINALE',
            _id: '628b7a761aa1df0004c2d21f',
        },

        { rs_name: 'BATTLE OF ITIUS', _id: '626ab39a65b71800048c2d69' },

        { rs_name: 'SOUTHTOWN CLASSIC QUALIF', _id: '62878e4c22090200041c9b58' },

        { rs_name: 'SEA FITNESS & SUN 2022', _id: '62b430255c0bfb00045763bc' },

        {
            rs_name: 'BARBE’L CONTEST MOONLIGHT EDITION',
            _id: '62a704133939d80004a74503',
        },

        { rs_name: 'WODABOX THROWDOWN 2022', _id: '6299dd1d6daeb20004c8ef2a' },

        { rs_name: 'FARMERS GAMES 2022', _id: '6247122e40b619000422ee1d' },

        { rs_name: 'WOLVES GANG CONTEST 2022', _id: '62c6dbdbc96c3b0004e2a312' },

        { rs_name: 'BATTLE OF MONSTERS 2022', _id: '62618cc707366e0004c7cf47' },

        {
            rs_name: 'BATTLE OF GENUM SUMMER EDITION',
            _id: '62ac84d7d9c7a90004867fdc',
        },

        { rs_name: 'PUMP-L-UP THROWDOWN 2022', _id: '62ac9251f689ed0004b15a3c' },

        {
            rs_name: 'ALPINE BATTLE ADVENTURE BY EKARA',
            _id: '620e4b5f2b196700044ee42f',
        },

        { rs_name: 'PROVENCE THROWDOWN 2022', _id: '628ccccb02807f0004a953eb' },

        {
            rs_name: 'CORMEILLES CONTEST 1ERE EDITION',
            _id: '6271344deafecf0004b4dbe7',
        },

        { rs_name: 'LH CONTEST 2.0 2022', _id: '6296055cc92952000481e250' },

        { rs_name: 'FOREZ BATTLE BACK TO SCHOOL', _id: '6298b93476d3a9000448169c' },

        {
            rs_name: 'ATLANTIC FIRE CONTEST EDITION 2022',
            _id: '624ef9de33abc00004e4d932',
        },

        { rs_name: 'ANGERS MENESTYS BIG CONTEST', _id: '620b5f87b0a70700045b1562' },

        { rs_name: 'THE MEET OF MADNESS', _id: '62c2e3dd699ec60004af40ec' },

        { rs_name: 'DRAGUIGNAN THROWDOWN 2022', _id: '62b30e935c0bfb0004574b1f' },

        { rs_name: 'FILATURE CONTEST EDITION 2', _id: '624e9792a7657300042901df' },

        { rs_name: 'PENN-AR-BED 2022 FINALE', _id: '6267c1f68882760004edd47b' },

        { rs_name: '7.2 THROWDOWN #6', _id: '61ec335b42947a0004afdc42' },

        { rs_name: 'PRIMAL CONTEST 2022', _id: '628cdfa3c5dd290004235bbf' },

        {
            rs_name: 'CROSSFIT TARBES CONTEST 2EME EDITION',
            _id: '62c2e0b1089e87000433f356',
        },

        { rs_name: 'BLACK MOUNTAIN CONTEST 2022', _id: '62d51d78f5eabb00044ad6cc' },

        { rs_name: 'TIGER CONTEST 2022', _id: '62b192eb60f9ea00043874d2' },

        {
            rs_name: 'HABEAS CORPUS GAMES INDIVIDUAL EDITION',
            _id: '62bac352eb72b80004346fbe',
        },

        { rs_name: 'CHARLEROI THROWDOWN 2022', _id: '629b1b08584f7a00045c7243' },

        { rs_name: 'BATTLE OF THE ELEMENTS 2022', _id: '621002da892b780004b4f2b4' },

        { rs_name: 'WARRIORS OF THE EAST 2022', _id: '623ddce40131ed0004d9b057' },

        { rs_name: 'HPP CONTEST SUMMER EDITION', _id: '62a1eef60ba1a50004a2f2e2' },

        { rs_name: 'DUO WILD BY GALILEO 2022', _id: '62d12421bc6c8c000493efb1' },

        { rs_name: 'PUMP’IN CONTEST 2022', _id: '62bc1bba677ee60004df3de9' },

        { rs_name: 'VELAY CONTEST #3', _id: '6266748da720580004fd7aac' },

        { rs_name: 'F*CK CANCER CONTEST #2', _id: '629861d9c22a710004a7c886' },

        { rs_name: 'ARENA FOOL RACE 2022', _id: '62790d12b10c3000046ab55b' },

        {
            rs_name: 'FITTEST OF 100 POURCENT EDITION 2',
            _id: '62c6b0b73d56c30004c21492',
        },

        {
            rs_name: 'LE BERCAIL CONTEST EDITION 2',
            _id: '62daa86db2bd2d00044a3778',
        },

        {
            rs_name: 'BEGINNER’S CONTEST WINTER EDITION',
            _id: '62b99f4e165ad5000461f42d',
        },

        { rs_name: 'GAMES OF WOD 2022', _id: '62ab3706e6f347000409a8db' },

        { rs_name: 'CONTEST 4 FUN EDITION 2', _id: '62d15d28205aa50004bade09' },

        {
            rs_name: 'THE FITTEST OF DRACENIE WINTER EDITION',
            _id: '62bda6debd5e0f000432d0b7',
        },

        {
            rs_name: 'TRUST YOURSELF CONTEST FRANCE 2023',
            _id: '6294ba2f36322c00045a01fa',
        },
    ],
    COEF_UPDATE_FUTURE_COMPETITIONS: {
        start_id: '62e108286fa498bee20a64a1',
        start_date: '2022-07-27T09:40:56.000Z',
    },
    VALMEIMIER_THROWDOWN: { _id: '616da856a4f60e0004c65177' },
}
